export default __webpack_public_path__ + "static/media/40253.338a2849.jpg";